import { Pipe, type PipeTransform } from '@angular/core';
import { type EventItem, type EventType, isEventWithLocation } from '../../core/models/middleware/event-item.model';

@Pipe({
  name: 'eventLocation',
  standalone: true,
})
export class EventLocationPipe implements PipeTransform {
  transform(event: EventItem<EventType>): string {
    if (!isEventWithLocation(event)) {
      return '';
    } else {
      const city = event.location?.city || '';
      const country = event.location?.country || '';

      if (country === 'Deutschland') {
        return city;
      }

      return city && country ? `${city}, ${country}` : city || country;
    }
  }
}
